(ns logseq.shui.ui
  (:require [logseq.shui.base.core :as base-core]
            [logseq.shui.dialog.core :as dialog-core]
            [logseq.shui.form.core :as form-core]
            [logseq.shui.form.password :as form-password]
            [logseq.shui.icon.v2 :as icon-v2]
            [logseq.shui.popup.core :as popup-core]
            [logseq.shui.select.core :as select-core]
            [logseq.shui.select.multi :as select-multi]
            [logseq.shui.shortcut :as shui.shortcut]
            [logseq.shui.table.core :as table-core]
            [logseq.shui.toaster.core :as toaster-core]
            [logseq.shui.util :as util]))

(def button base-core/button)
(def button-icon base-core/button-icon)
(def button-ghost-icon base-core/button-ghost-icon)
(def button-outline-icon base-core/button-outline-icon)
(def button-secondary-icon base-core/button-secondary-icon)
(def button-group (util/ui-wrap "ButtonGroup"))
(def toolbar (util/ui-wrap "Toolbar"))
(def toolbar-group (util/ui-wrap "ToolbarGroup"))
(def toolbar-button (util/ui-wrap "ToolbarButton"))
(def toolbar-input (util/ui-wrap "ToolbarInput"))
(def toolbar-link (util/ui-wrap "ToolbarLink"))
(def toolbar-separator (util/ui-wrap "ToolbarSeparator"))
(def link base-core/link)
(def trigger-as base-core/trigger-as)
(def trigger-child-wrap base-core/trigger-child-wrap)
(def shortcut shui.shortcut/root)
(def shortcut-press! shui.shortcut/shortcut-press!)
(def ^:export tabler-icon icon-v2/root)

(def alert (util/ui-wrap "Alert"))
(def alert-title (util/ui-wrap "AlertTitle"))
(def alert-description (util/ui-wrap "AlertDescription"))
(def slider (util/ui-wrap "Slider"))
(def slider-track (util/ui-wrap "SliderTrack"))
(def slider-range (util/ui-wrap "SliderRange"))
(def slider-thumb (util/ui-wrap "SliderThumb"))
(def separator (util/ui-wrap "Separator"))
(def badge (util/ui-wrap "Badge"))
(def skeleton (util/ui-wrap "Skeleton"))
(def calendar (util/ui-wrap "Calendar"))
(def avatar (util/ui-wrap "Avatar"))
(def avatar-image (util/ui-wrap "AvatarImage"))
(def avatar-fallback (util/ui-wrap "AvatarFallback"))
(def input form-core/input)
(def textarea form-core/textarea)
(def switch form-core/switch)
(def checkbox form-core/checkbox)
(def radio-group form-core/radio-group)
(def radio-group-item form-core/radio-group-item)
(def popover popup-core/popover)
(def popover-trigger popup-core/popover-trigger)
(def popover-content popup-core/popover-content)
(def popover-arrow popup-core/popover-arrow)

(def tooltip (util/ui-wrap "Tooltip"))
(def tooltip-trigger (util/ui-wrap "TooltipTrigger"))
(def tooltip-portal (util/ui-wrap "TooltipPortal"))
(def tooltip-content (util/ui-wrap "TooltipContent"))
(def tooltip-provider (util/ui-wrap "TooltipProvider"))
(def tooltip-arrow (util/ui-wrap "TooltipArrow"))

(def card (util/ui-wrap "Card"))
(def card-header (util/ui-wrap "CardHeader"))
(def card-title (util/ui-wrap "CardTitle"))
(def card-description (util/ui-wrap "CardDescription"))
(def card-content (util/ui-wrap "CardContent"))
(def card-footer (util/ui-wrap "CardFooter"))

(def form-provider form-core/form-provider)
(def form-item form-core/form-item)
(def form-label form-core/form-label)
(def form-description form-core/form-description)
(def form-message form-core/form-message)
(def form-field form-core/form-field)
(def form-control form-core/form-control)

(def select select-core/select)
(def select-group select-core/select-group)
(def select-value select-core/select-value)
(def select-trigger select-core/select-trigger)
(def select-icon select-core/select-icon)
(def select-content select-core/select-content)
(def select-label select-core/select-label)
(def select-item select-core/select-item)
(def select-separator select-core/select-separator)
(def select-scroll-up-button select-core/select-scroll-up-button)
(def select-scroll-down-button select-core/select-scroll-down-button)

(def dropdown-menu popup-core/dropdown-menu)
(def dropdown-menu-trigger popup-core/dropdown-menu-trigger)
(def dropdown-menu-content popup-core/dropdown-menu-content)
(def dropdown-menu-group popup-core/dropdown-menu-group)
(def dropdown-menu-item popup-core/dropdown-menu-item)
(def dropdown-menu-checkbox-item popup-core/dropdown-menu-checkbox-item)
(def dropdown-menu-radio-group popup-core/dropdown-menu-radio-group)
(def dropdown-menu-radio-item popup-core/dropdown-menu-radio-item)
(def dropdown-menu-label popup-core/dropdown-menu-label)
(def dropdown-menu-separator popup-core/dropdown-menu-separator)
(def dropdown-menu-shortcut popup-core/dropdown-menu-shortcut)
(def dropdown-menu-sub popup-core/dropdown-menu-sub)
(def dropdown-menu-sub-content popup-core/dropdown-menu-sub-content)
(def dropdown-menu-sub-trigger popup-core/dropdown-menu-sub-trigger)

(def context-menu (util/ui-wrap "ContextMenu"))
(def context-menu-trigger (util/ui-wrap "ContextMenuTrigger"))
(def context-menu-content (util/ui-wrap "ContextMenuContent"))
(def context-menu-item (util/ui-wrap "ContextMenuItem"))
(def context-menu-checkbox-item (util/ui-wrap "ContextMenuCheckboxItem"))
(def context-menu-radio-item (util/ui-wrap "ContextMenuRadioItem"))
(def context-menu-label (util/ui-wrap "ContextMenuLabel"))
(def context-menu-separator (util/ui-wrap "ContextMenuSeparator"))
(def context-menu-shortcut (util/ui-wrap "ContextMenuShortcut"))
(def context-menu-group (util/ui-wrap "ContextMenuGroup"))
(def context-menu-portal (util/ui-wrap "ContextMenuPortal"))
(def context-menu-sub (util/ui-wrap "ContextMenuSub"))
(def context-menu-sub-content (util/ui-wrap "ContextMenuSubContent"))
(def context-menu-sub-trigger (util/ui-wrap "ContextMenuSubTrigger"))
(def context-menu-radio-group (util/ui-wrap "ContextMenuRadioGroup"))

;; tabs
(def tabs (util/ui-wrap "Tabs"))
(def tabs-list (util/ui-wrap "TabsList"))
(def tabs-trigger (util/ui-wrap "TabsTrigger"))
(def tabs-indicator (util/ui-wrap "TabsIndicator"))
(def tabs-content (util/ui-wrap "TabsContent"))

(def dialog dialog-core/dialog)
(def dialog-portal dialog-core/dialog-portal)
(def dialog-overlay dialog-core/dialog-overlay)
(def dialog-close dialog-core/dialog-close)
(def dialog-trigger dialog-core/dialog-trigger)
(def dialog-content dialog-core/dialog-content)
(def dialog-header dialog-core/dialog-header)
(def dialog-footer dialog-core/dialog-footer)
(def dialog-title dialog-core/dialog-title)
(def dialog-description dialog-core/dialog-description)

(def toast! toaster-core/toast!)
(def toast-dismiss! toaster-core/dismiss!)
(def dialog-open! dialog-core/open!)
(def dialog-alert! dialog-core/alert!)
(def dialog-confirm! dialog-core/confirm!)
(def dialog-close! dialog-core/close!)
(def dialog-close-all! dialog-core/close-all!)
(def dialog-get dialog-core/get-dialog)
(def popup-show! popup-core/show!)
(def popup-hide! popup-core/hide!)
(def popup-hide-all! popup-core/hide-all!)

(def multi-select-content select-multi/x-select-content)

(def table-option table-core/table-option)
(def table table-core/table)
(def table-header table-core/table-header)
(def table-footer table-core/table-footer)
(def table-row table-core/table-row)
(def table-cell table-core/table-cell)
(def table-actions table-core/table-actions)
(def table-get-selection-rows table-core/get-selection-rows)

(def toggle-password form-password/toggle-password)
